import { render, staticRenderFns } from "./tvshows.vue?vue&type=template&id=71666486&"
import script from "./tvshows.vue?vue&type=script&lang=js&"
export * from "./tvshows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports